// AboutHero.js
import React from 'react';
import { motion } from 'framer-motion';

const AboutHero = () => {
  return (
    <section className="relative py-24 md:py-32 bg-[#F5F8FA] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Tag */}
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block bg-white text-[#2542D4] text-sm font-light px-6 py-2 rounded-md mb-6"
          >
            About Us
          </motion.span>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-6xl font-semibold text-[#202356] mb-6 leading-tight"
          >
            About Notapaths
          </motion.h1>

          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl md:text-2xl text-gray-600 font-light leading-relaxed"
          >
            Supporting global education and employment pathways with clarity, transparency, and structured guidance.
          </motion.p>

          {/* Decorative Elements */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-12 flex justify-center gap-2"
          >
            <div className="w-20 h-1 bg-[#202356]/20 rounded-full"></div>
            <div className="w-20 h-1 bg-[#202356]/40 rounded-full"></div>
            <div className="w-20 h-1 bg-[#202356]/20 rounded-full"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
